import React, { useContext, useEffect, useState } from 'react';
import { Col, Descriptions, Row, Skeleton } from 'antd';
import {
  Get_Matching_Prisma_User_Or_DriverQuery,
  GetClientBasicInfoQuery,
  GetMeQuery,
  useGet_Matching_Prisma_User_Or_DriverQuery,
  useGetClientBasicInfoLazyQuery,
  useGetMeQuery,
} from '../../graphql/datamodel.gen';
import { getClient } from '../../apollo';
import { MainContext } from '../../contexts/mainContext';

interface IProps {}

type User = GetMeQuery['user'];
type Client = GetClientBasicInfoQuery['client'];

const Profile: React.FC<IProps> = (props: IProps) => {
  const {
    loading: loadingUser,
    data: dataUser,
    error: errorUser,
  } = useGet_Matching_Prisma_User_Or_DriverQuery({
    client: getClient(),
    fetchPolicy: 'cache-and-network',
  });

  const [getClientQuery, { loading: clientLoading, data: dataClient }] =
    useGetClientBasicInfoLazyQuery({
      client: getClient(),
      fetchPolicy: 'cache-and-network',
      returnPartialData: false,
    });

  useEffect(() => {
    if (dataUser?.userOrDriver.__typename === 'User') {
      if (dataUser?.userOrDriver?.isClient) {
        getClientQuery();
      }
    }
  }, [dataUser, getClientQuery]);

  const user = dataUser?.userOrDriver;
  const client = dataClient?.client;

  const _loadingUser = !dataUser && loadingUser;
  const _loadingClient = !dataClient && clientLoading;

  const loading = _loadingUser || _loadingClient;

  if (loading) {
    return <Skeleton active={true} loading={true} />;
  }

  return <ProfileView user={user} client={client} />;
};

interface IViewProps {
  user: Get_Matching_Prisma_User_Or_DriverQuery['userOrDriver'];
  client?: Client;
}

const getUserTypeString = (
  userOrDriver: Get_Matching_Prisma_User_Or_DriverQuery['userOrDriver'],
) => {
  if (userOrDriver.__typename === 'User') {
    if (userOrDriver.isClient) {
      return 'Cliente';
    }

    if (userOrDriver.isAdmin) {
      return 'Administrador de MVIPs';
    }
  }

  if (userOrDriver.__typename === 'Driver') {
    if (userOrDriver.drivingCompany?.id) {
      return 'Conductor de Empresa Colabodarora';
    }
  }

  return 'Desconocido';
};

const getClientRole = (
  userOrDriver: Extract<
    Get_Matching_Prisma_User_Or_DriverQuery['userOrDriver'],
    { __typename: 'User' }
  >,
) => {
  if (userOrDriver.isClient) {
    if (userOrDriver.clientRole === 'ADMIN') {
      return 'Administrador';
    }

    if (userOrDriver.clientRole === 'EMPLOYEE') {
      return 'Empleado';
    }
  }
  return 'Desconocido';
};

const ProfileView: React.FC<IViewProps> = (props: IViewProps) => {
  const context = useContext(MainContext);
  const [editMode, setEditMode] = useState<boolean>(false);

  return (
    <>
      <Row>
        <Col span={8}>
          <Descriptions
            title="Información de tu cuenta"
            column={2}
            layout={'vertical'}
          >
            <Descriptions.Item label={<b>Tipo de usuario</b>}>
              {getUserTypeString(props.user)}
            </Descriptions.Item>
            {props.user?.__typename === 'User' && props.user?.isClient && (
              <Descriptions.Item label={<b>Rol</b>}>
                {getClientRole(props.user)}
              </Descriptions.Item>
            )}
            {context.name && (
              <Descriptions.Item label={<b>Nombre</b>}>
                {context.name}
              </Descriptions.Item>
            )}
            {props.client?.phone && (
              <Descriptions.Item label={<b>Teléfono</b>}>
                {props.client?.phone}
              </Descriptions.Item>
            )}
            {props.client?.email && (
              <Descriptions.Item label={<b>Email principal</b>}>
                {props.client?.email}
              </Descriptions.Item>
            )}
            {props.client?.email && (
              <Descriptions.Item label={<b>Email secundario</b>}>
                {props.client?.volcanoEmail}
              </Descriptions.Item>
            )}
          </Descriptions>
        </Col>
        <Col span={12}></Col>
      </Row>
    </>
  );
};

export default Profile;
